import React from "react";
import { Header } from "../header/Header";
import { Sidebar } from "../sidebar/Sidebar";

export const Setting = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <div
        className="main-content mt-5 px-3 px-md-4 py-4"
        style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}
      >
        <section className="content-section" id="settings">
          <div className="section-header">
            <h1>Settings</h1>
          </div>
          <div className="settings-grid">
            <div className="card">
              <div className="card-header">
                <h3>Admin Configuration</h3>
              </div>
              <div className="card-body">
                <form className="settings-form">
                  <div className="form-group">
                    <label>Site Name</label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue="Advocate Matrimony"
                    />
                  </div>
                  <div className="form-group">
                    <label>Admin Email</label>
                    <input
                      type="email"
                      className="form-control"
                      defaultValue="admin@advocatematrimony.com"
                    />
                  </div>
                  <div className="form-group">
                    <label>Contact Phone</label>
                    <input
                      type="tel"
                      className="form-control"
                      defaultValue="+91 9876543210"
                    />
                  </div>
                </form>
              </div>
            </div>
            <div className="card">
              <div className="card-header">
                <h3>Notification Preferences</h3>
              </div>
              <div className="card-body">
                <div className="settings-form">
                  <div className="form-group">
                    <label className="checkbox-label">
                      <input type="checkbox" defaultChecked />
                      <span>Email notifications for new registrations</span>
                    </label>
                  </div>
                  <div className="form-group">
                    <label className="checkbox-label">
                      <input type="checkbox" defaultChecked />
                      <span>SMS alerts for payments</span>
                    </label>
                  </div>
                  <div className="form-group">
                    <label className="checkbox-label">
                      <input type="checkbox" />
                      <span>Weekly analytics report</span>
                    </label>
                  </div>
                  <div className="form-group">
                    <label className="checkbox-label">
                      <input type="checkbox" defaultChecked />
                      <span>Profile verification alerts</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="card full-width">
              <div className="card-header">
                <h3>System Settings</h3>
              </div>
              <div className="card-body">
                <form className="settings-form">
                  <div className="form-group">
                    <label>Auto-approve profiles after</label>
                    <select className="form-control">
                      <option>Manual Review</option>
                      <option>24 hours</option>
                      <option>48 hours</option>
                      <option>72 hours</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Profile expiry (days)</label>
                    <input
                      type="number"
                      className="form-control"
                      defaultValue={180}
                    />
                  </div>
                  <div className="form-group">
                    <label>Maximum interests per month (Basic plan)</label>
                    <input
                      type="number"
                      className="form-control"
                      defaultValue={5}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="settings-actions">
            <button className="btn btn-primary" onclick="saveSettings()">
              💾 Save All Settings
            </button>
            <button className="btn btn-secondary">🔄 Reset to Defaults</button>
          </div>
        </section>
      </div>
    </>
  );
};
